<template>
  <TheTermsAndConditions :to="{ name: 'depositsFiatSteps' }" />
</template>

<script>
import TheTermsAndConditions from '@/components/account/blocks/TheTermsAndConditions'

export default {
  name: 'FIATTermsAndConditions',
  components: {
    TheTermsAndConditions,
  },
}
</script>
